// Builds an Expedia flight-search URL wrapped with the user's Partnerize tracking redirect,
// so that clicks on the "Book Flight" button credit the affiliate camref.

const CAMREF = process.env.REACT_APP_EXPEDIA_CAMREF;
const PARTNERIZE_PREFIX = 'https://prf.hn/click/camref:';
const EXPEDIA_FLIGHTS_URL = 'https://www.expedia.com/Flights-Search';

const formatExpediaDate = (iso) => {
  const d = new Date(iso);
  if (isNaN(d)) return null;
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${m}/${day}/${d.getFullYear()}`;
};

/**
 * Build a Partnerize-tracked Expedia round-trip flight search URL.
 * @param {string} originIata
 * @param {string} destIata
 * @param {string} departIso ISO timestamp for outbound departure
 * @param {string|null} returnIso ISO timestamp for return departure (null = one-way)
 * @returns {string|null} Trackable URL, or null if inputs are insufficient.
 */
export const buildExpediaFlightUrl = (originIata, destIata, departIso, returnIso) => {
  if (!CAMREF) {
    console.warn('Expedia: REACT_APP_EXPEDIA_CAMREF not set, skipping affiliate link.');
    return null;
  }
  if (!originIata || !destIata || !departIso) return null;

  const depart = formatExpediaDate(departIso);
  const ret = returnIso ? formatExpediaDate(returnIso) : null;
  if (!depart) return null;

  const isRoundTrip = !!ret;
  const url = new URL(EXPEDIA_FLIGHTS_URL);
  url.searchParams.set('mode', 'search');
  url.searchParams.set('trip', isRoundTrip ? 'roundtrip' : 'oneway');
  url.searchParams.set('leg1', `from:${originIata},to:${destIata},departure:${depart}TANYT`);
  if (isRoundTrip) {
    url.searchParams.set('leg2', `from:${destIata},to:${originIata},departure:${ret}TANYT`);
  }
  url.searchParams.set('passengers', 'adults:1');

  return `${PARTNERIZE_PREFIX}${CAMREF}/destination:${encodeURIComponent(url.toString())}`;
};
